// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"241":"73ecfb4a","287":"bf15cf3a","330":"dae7c10f","370":"482c9601","449":"4d468ab6","713":"248a4597","832":"706150b2","915":"ed96e983","969":"f076772d"}[chunkId] + ".js";
};